<template lang="pug">
	no-ssr
		span
			div.urgent-container.d-none(v-if="(ready && show)" :class="{'in-page' : inPage, 'd-lg-block': !inPage, 'd-xl-block': inPage, 'version-2': !inPage && version == 'v2' }" v-observe-visibility="trackShownEvent")
				b-container
					b-row.no-gutters.content(v-show="floridaPrepaid")
						b-col(:class="`${inPage? 'col-7': 'col-8'}`")
							h2.title Attention {{computedState.name}} Residents!
							div
								| {{copy1April}}&nbsp;
								br(v-show="!inPage && copy2April != ''")
								span(v-show="inPage") &nbsp;
								span(v-show="copy2April != '' ") {{copy2April}}&nbsp;
								a.urgent(:href="callToActionApril" @click="trackClick()")
									| Enroll today
								|.
						b-col.float-right(:class="`${inPage? 'col-5': 'col-4'}`")
							div.countdown-container.d-inline-block.float-right
								div.counter
									div.count
										| {{days}}
									div days
								div.counter
									div.count
										| {{hours}}
									div hours
								div.counter
									div.count
										| {{minutes}}
									div minutes
								div.counter
									div.count
										| {{seconds}}
									div seconds
								div.close-btn.d-inline-block(:class="{'hidden': inPage}" @click="hideBanner()")
									sfc-x-icon
</template>
<style lang="stylus">
@import '~assets/css/variables.styl'

.urgent-container
	.container
		padding: 0
	.close-btn
		cursor: pointer
		position: absolute
		top: 35px
		right: -15px
		opacity: 0.7
		transition-all()
		svg
			padding: 3px
			path
				fill: sfc-blue-dark-text
		&:hover
			opacity: 1
		&.hidden
			display: none !important


</style>
<style lang="stylus" scoped>
@import '~assets/css/variables.styl'

.button-container
	a
		width: 100%
.urgency-container
	width: 100%

.urgent-container
	background-color: #ECF6FE
	width: 100%
	padding: 30px

	.content
		width: 100%

	a.urgent
		color: urgent-red
		text-decoration: underline
	> .container
		display: flex
		@media (max-width: 768px)
			flex-direction: column
			.countdown-container
				padding: 15px
		h2
			color: urgent-red
			text-transform: uppercase
			margin-bottom: 0
		p
			padding-right: 30px
			margin-bottom: 0
		.countdown-container
			width: 270px
			.counter
				display: inline-block
				padding: 10px 5px
				font-size: body-font-size-xxs
				background: #CFDFF6
				text-align: center
				margin: 3px
				min-width: 60px
				border-radius(4px)
				color: #303030
				text-transform: uppercase
				&:first-child
					margin-left: 0
				&:last-child
					margin-right: 0
				.count
					font-size: body-font-size-xl
					font-weight: body-font-weight-strong
	&.in-page
		border: 1px solid #4b89DE
		margin: 30px auto
		background: #ECF6FE
		.close-btn
			display: none

	@media(max-width: 768px)
		.countdown-container
			padding-bottom: 0px
		p
			padding-right: 0px!important
		.close-btn
			position: absolute
			top: 15px
			right: 15px
			left: auto

.version-2
	padding: 30px 0 20px 0
	.click-button
		border-color: #D0021B !important
		background-color: #F05B33 !important
		&:hover
			background-color: #e2491f !important
	.title
		font-size: body-font-size-lg-plus

	.close-btn
		top: -35px
</style>

<script>
	import SfcTrackingService from "@/lib/sfc-tracking-service"
	import Vue from 'vue'
	import VueObserveVisibility from 'vue-observe-visibility'
	Vue.use(VueObserveVisibility)

	export default {
		data(){
			let randomNumber = Math.ceil(Math.random() * 100)
			let version = "v1"
			return {
				ready: false,
				show: true,
				version,
				shownEventAlreadySent: false,
				timeAtDecember31: new Date(),
				currentTime: new Date(),
				currentTimeInMiliseconds: 0,
				timeAtDecember31InMiliseconds: 0,
				timeLeftInMiliseconds: 0,
				days: 0,
				hours: 0,
				minutes: 0,
				seconds: 0,
				// statesStringIdArray: ["AL", "AZ", "CO", "DC", "ID", "IL", "IN", "MD", "MA", "MO", "NE", "NM", "NY", "ND", "OH", "RI", "VA"],
				floridaPrepaid: true,
				statesStringIdArray: ["FL", "SC", "IA"],
				statesWithData: [
					{id: "AL", deduction: true, credit: false, parity: false, single: 5000, couple: 10000},
					{id: "AZ", deduction: false, credit: false, parity: true, single: 2000, couple: 4000},
					{id: "CO", deduction: true, credit: false, parity: false, single: 999999, couple: 999999},
					{id: "DC", deduction: true, credit: false, parity: false, single: 4000, couple: 8000},
					{id: "ID", deduction: true, credit: false, parity: false, single: 6000, couple: 12000},
					{id: "IL", deduction: true, credit: false, parity: false, single: 10000, couple: 20000},
					{id: "IN", deduction: false, credit: true, parity: false, single: 5000, couple: 5000, creditPercentage: 20},
					{id: "MD", deduction: true, credit: false, parity: false, single: 2500, couple: 5000},
					{id: "MA", deduction: true, credit: false, parity: false, single: 1000, couple: 2000},
					{id: "MO", deduction: false, credit: false, parity: true, single: 8000, couple: 16000},
					{id: "NE", deduction: true, credit: false, parity: false, single: 10000, couple: 10000},
					{id: "NM", deduction: true, credit: false, parity: false, single: 999999, couple: 999999},
					{id: "NY", deduction: true, credit: false, parity: false, single: 5000, couple: 10000},
					{id: "ND", deduction: true, credit: false, parity: false, single: 5000, couple: 10000},
					{id: "OH", deduction: true, credit: false, parity: false, single: 4000, couple: 4000},
					{id: "RI", deduction: true, credit: false, parity: false, single: 500, couple: 1000},
					{id: "VA", deduction: true, credit: false, parity: false, single: 4000, couple: 4000}
				],
				currentStateWithData: {}
			}
		},
		props: {
			inPage:{
				default: true
			},
			state:{
				default: null
			}
		},
		mounted(){
			try{
				this.startCountdown()
			} catch {

			}
		},

		computed:{
			copy(){
				if(this.statesStringIdArray.indexOf(this.computedState.id) == -1){
					return
				}

				if(this.currentStateWithData.deduction){
					if(this.currentStateWithData.single == 999999){
						return "Time is running out! Open and fund your state's 529 plan by December 31st to claim your state tax deduction."
					} else{
						return `Time is running out! Open and fund your state's 529 plan by December 31st to claim your state tax deduction of up to ${Vue.filter('currency')(this.currentStateWithData.couple,'$',0)}.`
					}

				}

				if(this.currentStateWithData.parity){
					return `Time is running out! Open and fund any 529 plan by December 31st to claim your state tax deduction of up to ${Vue.filter('currency')(this.currentStateWithData.couple,'$',0)}.`
				}

				if(this.currentStateWithData.credit){
					return `Time is running out! Open and fund your state's 529 plan by December 31st to claim your state tax credit of up to ${Vue.filter('currency')(this.currentStateWithData.couple * this.currentStateWithData.creditPercentage / 100,'$',0)}.`
				}
			},
			computedState(){
				if(this.state){
					return this.state
				}

				return this.$store.state.stateFromIp
			},
			copy1April(){
				if(this.computedState.id == "FL"){
					return "Open enrollment is NOW!"
				}

				if(this.computedState.id == "SC"){
					return "There's still time to claim a 2018 tax deduction for South Carolina. Open and fund your state's 529 plan by April 15, 2019 to claim your state's tax deduction."
				}

				if(this.computedState.id == "IA"){
					return "There's still time to claim a 2018 tax deduction for Iowa. Open and fund your state's 529 plan by April 30, 2019 to claim your state's tax deduction of up to $6,774."
				}

				return ""
			},
			copy2April(){
				if(this.computedState.id == "FL"){
					return "The clock is ticking, last day to enroll in a Florida Prepaid plan is 4/30."
				}

				if(this.computedState.id == "SC"){
				}

				if(this.computedState.id == "IA"){

				}

				return ""
			},
			callToActionApril(){
				if(this.computedState.id == "FL"){
					return "https://www.savingforcollege.com/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=11&click_source=sfc_enroll_now_urgency_widget"
				}

				if(this.computedState.id == "SC"){
					return "https://www.savingforcollege.com/529-plans/south-carolina/future-scholar-529-college-savings-plan-direct-sold"
				}

				if(this.computedState.id == "IA"){
					return "https://www.savingforcollege.com/529-plans/iowa/college-savings-iowa"
				}

				return ""
			}


		},

		methods: {
			trackShownEvent(isVisible, entry){
				if(!this.shownEventAlreadySent && isVisible && !this.inPage){
					this.shownEventAlreadySent = true
					SfcTrackingService.trackAnalyticsAction("Enroll now urgency banner", 'show', this.version)
				}
			},
			trackClick(){
				SfcTrackingService.trackAnalyticsAction("Enroll now urgency banner", 'click', this.version)
			},
			trackDismiss(){
				SfcTrackingService.trackAnalyticsAction("Enroll now urgency banner", 'dismiss', this.version)
			},
			hideBanner(){
				this.$cookies.set("sfc-urgency-banner", true, {
					path: '/',
					domain: 'savingforcollege.com',
					maxAge: 365 * 24 * 60 * 60
				})
				this.show = false
				this.trackDismiss()

			},

			startCountdown(){
				if(this.statesStringIdArray.indexOf(this.computedState.id) == -1){
					return
				}

				if(this.$cookies.get("sfc-urgency-banner") && !this.inPage){
					return
				}

				if(this.$route.path.indexOf("/529-plans") != -1 && !this.inPage){
					return
				}

				this.currentStateWithData = this.statesWithData.filter( state => state.id == this.computedState.id)[0]

				this.currentTime = new Date()
				this.currentTimeInMiliseconds = this.currentTime.getTime()
				if(this.computedState.id == 'SC'){
					this.timeAtDecember31 = new Date('April 15, 2019 23:59:59')
				}else{
					this.timeAtDecember31 = new Date('April 30, 2019 23:59:59')
				}
				this.timeAtDecember31InMiliseconds = this.timeAtDecember31.getTime()
				this.timeLeftInMiliseconds = this.timeAtDecember31InMiliseconds - this.currentTimeInMiliseconds
				if(this.timeLeftInMiliseconds <= 1000){
					return
				}else{
					this.ready = true
					this.countdown(this.timeLeftInMiliseconds)

				}
			},
			countdown(timeLeft){
				if(timeLeft < 1000){
					this.ready = false
					return
				}else{
					this.days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
					this.hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
					this.minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
					this.seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
					setTimeout( () => {
						this.countdown(timeLeft - 1000)
					}, 1000)
				}

			},
		},
	}
</script>
